//src/app/features/questionnaires/create/TaxRequestTarget/preview.tsx
import { useGetProjectByIdQuery } from 'app/services/projects';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PreviewExpandable from '../../components/PreviewExpandable';
import PreviewTable from '../../components/PreviewTable';
import { selectPrepareQuestionnaire } from '../PrepareQuestionnaire/slice';
import { useGetFields } from './fields';

export default function PreviewTaxRequestDetails() {
  const [fields] = useState(useGetFields());
  const values = useSelector(selectPrepareQuestionnaire);
  const { questionnaireId } = useParams();
  const { data } = useGetProjectByIdQuery(questionnaireId!, {
    skip: !questionnaireId,
  });

  return (
    <PreviewExpandable title="Tax Request Details">
      <PreviewTable
        fields={fields}
        fieldsState={{
          values: { ...values, businessId: data?.project?.businesses[0]?.name },
        }}
        sectionName="Tax Request Details"
      />
    </PreviewExpandable>
  );
}
